const SmsConfigurationApiUrls = {
  GET: `${process.env.REACT_APP_USER_ACI_SHARED_URL}/shared/sms-configuration/get`,
  POST: `${process.env.REACT_APP_USER_ACI_SHARED_URL}/shared/sms-configuration/create`,
  PUT: `${process.env.REACT_APP_USER_ACI_SHARED_URL}/shared/sms-configuration/update`,
  DELETE: `${process.env.REACT_APP_USER_ACI_SHARED_URL}/shared/sms-configuration/delete`,
  EXPORT: `${process.env.REACT_APP_USER_ACI_SHARED_URL}/shared/sms-configuration/download`,
}

export default SmsConfigurationApiUrls
